module.exports = __webpack_public_path__ + "img/warning.e7db9a1d.svg";